const middleware = {}

middleware['check-before-move'] = require('../middleware/check-before-move.js')
middleware['check-before-move'] = middleware['check-before-move'].default || middleware['check-before-move']

export default middleware
